export default __webpack_public_path__ + "static/media/target_gold.e10e5cfa.png";